import React from 'react';
import { useAuth } from '../../shared/contexts/AuthContext';
import './AccountDeletionOverlay.css';

const AccountDeletionOverlay = () => {
  const { deletionState } = useAuth();
  const { status, message } = deletionState;

  if (status === 'inactive') {
    return null;
  }

  return (
    <div className="deletion-overlay">
      <div className="deletion-content">
        {status === 'deleting' && (
          <>
            <div className="spinner"></div>
            <p>계정 삭제 중...</p>
            <span>모든 데이터를 안전하게 삭제하고 있습니다.</span>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <p>{message}</p>
            <span>잠시 후 자동으로 이동합니다.</span>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="error-icon">!</div>
            <p>오류 발생</p>
            <span>{message}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default AccountDeletionOverlay;
